
import { computed, defineComponent, onMounted, PropType, ref } from "vue";
import { Message } from "@/types/conversation";
import { useConversation } from "@/composables/conversation";
import { useWidgetTheme } from "@/composables/widgetTheme";
import { css } from "@emotion/css";

export default defineComponent({
  name: "MessengerMessageAttachments",
  props: {
    message: {
      type: Object as PropType<Message>,
      required: true,
    },
  },
  setup(props, { slots }) {
    const { conversation } = useConversation();
    const { theme } = useWidgetTheme();

    const hasBottomSlot = computed(() => !!slots.bottom);

    const canShowSpinner = ref(false);

    const files = computed(() => {
      return props.message.data.attachments;
    });

    const messageIsFromAgent = computed(
      () =>
        props.message.data.authorType === "agent" ||
        props.message.data.authorType === "system"
    );
    const messageIsFromClient = computed(
      () => props.message.data.authorType === "client"
    );

    const isFromPreviousConversation = computed(() => {
      if (conversation.value?.isEnded) {
        return true;
      }

      if (
        props.message.acknowledged &&
        props.message.conversationId !== conversation.value?.id
      ) {
        return true;
      }

      return false;
    });

    onMounted(() => {
      setTimeout(() => {
        // Prevent showing spinner until the message remains un-acknowledged for an abnormally long time
        canShowSpinner.value = true;
      }, 3000);
    });

    const outboundStyleClass = computed(
      () => css`
        background-color: ${theme.value?.primaryColor};
        color: ${theme.value?.primaryTextColor};

        &.pending {
          filter: brightness(85%);
        }
      `
    );

    const inboundStyleClass = computed(
      () => css`
        background-color: ${theme.value?.secondaryColor};
        color: ${theme.value?.secondaryTextColor};
      `
    );

    return {
      messageIsFromAgent,
      messageIsFromClient,
      isFromPreviousConversation,
      hasBottomSlot,
      outboundStyleClass,
      inboundStyleClass,
      files,
    };
  },
});
